import './theme-bootstrap.js';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { createAppRouter } from './router/index.js';
import { setApiHandlers } from './api/client.js';
import { loginLocationFor } from './router/guards.js';
import { useAuthStore } from './stores/auth.js';
import './styles/index.css';

const app = createApp(App);
app.use(createPinia());
const router = createAppRouter();
app.use(router);

setApiHandlers({
  on401: () => {
    const auth = useAuthStore();
    auth.clear();
    const here = location.pathname + location.search;
    void router.push(loginLocationFor(here));
  },
});

app.mount('#app');
